/**
 * UBL Hook for Size Info Container
 *
 * @description 사이즈탭 메뉴 UBL 로깅
 */
import { useUBL, useUBLContext } from '@common/log-manager';

export const useSizeInfoContainerUBL = () => {
  const sendUBL = useUBL();
  const ublContext = useUBLContext();

  const navigation = ublContext.navigation || 'product_detail';

  /**
   * 사이즈탭 메뉴 노출
   */
  const subtabSizeImpressionUBL = () => {
    sendUBL({
      category: 'impression',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'subtab_size',
      object_type: 'button',
      object_id: 'subtab_size',
      data: ublContext.data,
    });
  };

  /**
   * 사이즈탭 메뉴 클릭
   */
  const subtabSizeClickUBL = () => {
    sendUBL({
      category: 'click',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'subtab_size',
      object_type: 'button',
      object_id: 'subtab_size',
      data: ublContext.data,
    });
  };

  return {
    // impression
    subtabSizeImpressionUBL,
    // click
    subtabSizeClickUBL,
  };
};
